'use client'

import React from 'react'
import { MobileAppPromotion } from './mobileAppPromotion'
import { useLocale, useTranslations } from 'next-intl'

interface MobileAppPromotionWrapperProps {
    verticalLayout?: boolean
}

const MobileAppPromotionWrapper: React.FC<MobileAppPromotionWrapperProps> = ({ verticalLayout = false }) => {
    const t = useTranslations('homePage.promotion')
    const tFooter = useTranslations('footer')
    const locale = useLocale()

    return <MobileAppPromotion t={t} tFooter={tFooter} isRtl={locale === 'ar'} verticalLayout={verticalLayout} />
}

export { MobileAppPromotionWrapper }
export default MobileAppPromotionWrapper
